/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { configureEventCategoriesActions } from './slice';
import API from './constants';
/**
 * Event category configuration generator function to get major event categories
 * @param {*} payload
 */
export function* eventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.configureEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.configureEventCategoriesFailed(error?.message));
  }
}
/**
 * Add minor event category configuration generator function to add minor event categories
 * @param {*} payload
 */
export function* addMinorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.ADD_MINOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.addMinorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.addMinorEventCategoriesFailed(error?.message));
  }
}
/**
 * Get Minor event category configuration generator function to get minor event categories
 * @param {*} payload
 */
export function* getMinorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_MINOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.getMinorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.getMinorEventCategoriesFailed(error?.message));
  }
}
/**
 * Update minor event categories configuration generator function to update multiple minor event categories
 * @param {*} payload
 */
export function* updateMinorEventCategoriesConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.UPDATE_MINOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.updateMinorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.updateMinorEventCategoriesFailed(error?.message));
  }
}
/**
 * Delete minor event category configuration generator function to delete minor event categories
 * @param {*} payload
 */
export function* deleteMinorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.DELETE_MINOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.deleteMinorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.deleteMinorEventCategoriesFailed(error?.message));
  }
}
//
export function* eventCategoryConfigurationSaga() {
  yield takeLatest(
    configureEventCategoriesActions.configureEventCategories.type,
    eventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.addMinorEventCategories.type,
    addMinorEventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.getMinorEventCategories.type,
    getMinorEventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.updateMinorEventCategories.type,
    updateMinorEventCategoriesConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.deleteMinorEventCategories.type,
    deleteMinorEventCategoryConfigurationGenerator
  );
}
//
export default eventCategoryConfigurationSaga;
